/**
 * Coach summary helpers — riepilogo umano-leggibile delle operazioni applicate.
 *
 * Usato da Setup/Monthly/Weekly chat dopo handleConfirmOps per mostrare
 * sotto il messaggio del coach una lista di righe tipo:
 *   "KR «Incassato Qubit 2026» aggiornato — target → 600000 · scadenza → 30/09/2026"
 *
 * Riceve `results` da applyOperations() (`{entita, azione, data}`) e
 * deriva la riga leggibile usando i campi salvati realmente (non l'LLM).
 */

const CAMPO_LABEL = {
  scadenza: 'scadenza', target_committed: 'target', target_stretch: 'target stretch',
  valore_attuale: 'valore', baseline: 'baseline', confidence: 'confidence',
  stato: 'stato', titolo: 'titolo', testo: 'testo', data: 'data', area: 'area',
  perche: 'perché', tema: 'tema',
};

const ENTITA_NOME = {
  obiettivo: 'Obiettivo', key_result: 'KR', mit: 'MIT', azione: 'Azione',
  review: 'Review', revisione: 'Revisione', numero_importante: 'Numero',
  target_periodo: 'Target', capacita: 'Capacità', anno: 'Anno',
};

function fmtData(v) {
  // 2026-09-30 -> 30/09/2026
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)) {
    const [y, m, d] = v.slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
  }
  return v;
}

export function formatAppliedResult(r) {
  if (!r || !r.data) return null;
  const nome = r.data.titolo || r.data.testo || '';
  const tipo = ENTITA_NOME[r.entita] || r.entita;
  // verbo dall'azione applicata; duplicato_evitato = il coach ha proposto
  // 'crea' ma il record esisteva già → il backend ha restituito l'esistente.
  const verbo = r.duplicato_evitato
    ? 'già presente · riutilizzato'
    : r.azione === 'crea' ? 'creato' : r.azione === 'chiudi' ? 'chiuso' : 'aggiornato';
  // prova a mostrare il/i campo/i chiave variati (data, target, stato…)
  const campiInteressanti = ['scadenza', 'target_committed', 'stato', 'data', 'valore_attuale'];
  const dettagli = campiInteressanti
    .filter((k) => r.data[k] != null)
    .slice(0, 2)
    .map((k) => `${CAMPO_LABEL[k] || k} → ${k === 'scadenza' || k === 'data' ? fmtData(r.data[k]) : r.data[k]}`);
  const coda = dettagli.length ? ` — ${dettagli.join(' · ')}` : '';
  return `${tipo} «${nome}» ${verbo}${coda}`;
}
